module.exports = __webpack_public_path__ + "loader.4cc848b538580780aa52.gif";


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/assets/img/loader.gif
// module id = ../../../../../src/assets/img/loader.gif
// module chunks = 2